import type { SVGProps } from "react";

function LexiconLogoNoText(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg1"
      width="533.487"
      height="350.611"
      version="1.1"
      viewBox="0 0 141.152 92.766"
      {...props}
    >
      <g id="layer1" stroke="#ff862f" transform="translate(-30.861 -99.894)">
        <path
          id="rect14"
          fill="#fff"
          fillOpacity="1"
          strokeWidth="1.595"
          d="M31.659 110.914c23.534-15.202 46.614-11.557 69.503 0v80.344c-21.81-12.956-45.102-11.777-69.503 0z"
        ></path>
        <path
          id="rect14-6"
          fill="#fff"
          fillOpacity="1"
          strokeWidth="1.595"
          d="M101.713 110.75c23.534-15.202 46.614-11.557 69.503 0v80.345c-21.811-12.956-45.102-11.777-69.503 0z"
        ></path>
        <g
          id="rect26"
          fill="#ff862f"
          fillOpacity="0"
          fillRule="evenodd"
          strokeOpacity="1"
          opacity="1"
          transform="matrix(1.1259 0 0 .80567 61.516 94.544)"
        >
          <path
            id="path26"
            fill="#ff862f"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="#ff862f"
            strokeOpacity="1"
            strokeWidth="0.481"
            d="m16.578 11.335 14.824 6.763.293 27.131c-5.75-17.934-10.443-12.319-14.822 0z"
            baselineShift="baseline"
            display="inline"
            overflow="visible"
            stopColor="#000"
            stopOpacity="1"
            vectorEffect="none"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default LexiconLogoNoText;
